module.exports = __webpack_public_path__ + "img/link_salespartners.eee2dc3b.jpg";